import './calendar-radio.style.sass';
import template from './calendar-radio.tpl.pug';

export default {
    selector: 'dbACalendarRadio',
    template: template(),
    bindings: {
        name: '<',
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/calendar-radio/calendar-radio.cmpt.js